import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import '../../styles/components/headerMobile.scss';
import { PageRoutes, useStore, useViewModel } from '@utils';
import { BellMobile, BurgerMenu, LoginLogo } from '../svgs';
import { Link, useLocation } from 'react-router-dom';
import { PushStore } from '../../store';
import { FilterViewModel } from '../filter';
import { HeaderMobileLeftPart } from './HeaderMobileLeftPart';

export const HeaderMobile: FC = observer(() => {
  const pushStore = useStore(PushStore);
  const filterViewModel = useViewModel(FilterViewModel);

  const location = useLocation();
  const isCalendarPage = location.pathname === PageRoutes.CALENDAR_PAGE;

  const onOpenFilter = () => {
    filterViewModel.setOpenPanel(!filterViewModel.openPanel);
  };

  useEffect(() => pushStore.connect(), []);
  return (
    <div className='header-mobile'>
      {!filterViewModel.openPanel && (
        <>
          <div className='left-header-part'>
            {isCalendarPage
              ? (
                <HeaderMobileLeftPart 
                  selectEmployeeId={filterViewModel.selectEmployeeId}
                  resetEmployee={filterViewModel.resetEmployeeAndRoom}
                />
              )
              : (
                <Link className='reset-link' to={PageRoutes.CALENDAR_PAGE}>
                  <LoginLogo allClassName='header-logo'/>
                </Link>
              )
            }
          </div>
          <div className='settings-bar-mobile'>
            <Link to={PageRoutes.PUSH_PAGE}><BellMobile /></Link>
            <BurgerMenu onClick={onOpenFilter}/>
          </div>
        </>
      )}
    </div>
  );
});
